var _rect, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicePartime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_173_3429)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 41,
    r: 18,
    fill: "url(#paint1_linear_173_3429)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0003 28.6667C39.0003 28.1144 38.5526 27.6667 38.0003 27.6667C37.448 27.6667 37.0003 28.1144 37.0003 28.6667H39.0003ZM43.5627 44.6994C44.041 44.9755 44.6526 44.8116 44.9287 44.3333C45.2048 43.855 45.0409 43.2434 44.5627 42.9673L43.5627 44.6994ZM38.0003 38.0239H37.0003H38.0003ZM40.0004 41.488L39.5004 42.3541L40.0004 41.488ZM38.2683 40.1786L39.1343 39.6786L38.2683 40.1786ZM37.0003 28.6667L37.0003 38.0239L39.0003 38.0239L39.0003 28.6667H37.0003ZM44.5627 42.9673L40.5004 40.622L39.5004 42.3541L43.5627 44.6994L44.5627 42.9673ZM60.3337 38C60.3337 50.3344 50.3347 60.3333 38.0003 60.3333V62.3333C51.4393 62.3333 62.3337 51.4389 62.3337 38H60.3337ZM38.0003 60.3333C25.666 60.3333 15.667 50.3344 15.667 38H13.667C13.667 51.4389 24.5614 62.3333 38.0003 62.3333V60.3333ZM15.667 38C15.667 25.6656 25.666 15.6667 38.0003 15.6667V13.6667C24.5614 13.6667 13.667 24.5611 13.667 38H15.667ZM38.0003 15.6667C50.3347 15.6667 60.3337 25.6656 60.3337 38H62.3337C62.3337 24.5611 51.4393 13.6667 38.0003 13.6667V15.6667ZM37.0003 38.0239C37.0003 38.568 36.9992 39.0479 37.0386 39.448C37.0802 39.8699 37.1723 40.2804 37.4023 40.6786L39.1343 39.6786C39.0963 39.6128 39.0544 39.5094 39.029 39.2518C39.0014 38.9723 39.0003 38.6069 39.0003 38.0239L37.0003 38.0239ZM40.5004 40.622C39.9955 40.3305 39.6796 40.1468 39.4513 39.9832C39.2409 39.8324 39.1723 39.7445 39.1343 39.6786L37.4023 40.6786C37.6322 41.0769 37.9416 41.3618 38.2862 41.6088C38.613 41.843 39.0292 42.082 39.5004 42.3541L40.5004 40.622Z",
    fill: "#070707"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_3429",
    x1: 69.6667,
    y1: 60.1667,
    x2: 0.0000165534,
    y2: 14.6458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE73C",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_3429",
    x1: 31.3529,
    y1: 45,
    x2: 56.7647,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE73C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePartime);
export default __webpack_public_path__ + "static/media/service_partime.881def30a43c744c9233384bfd7f5602.svg";
export { ForwardRef as ReactComponent };